<template>
  <div class="main">
    <!-- title -->
    <h3 class="title" content="edit" placement="bottom">
      Content Management - Our Products
      <el-button
        style="width: 180px"
        type="primary"
        @click="handleAdd()"
        v-if="$store.state.userLevel <= 2"
        >Create</el-button
      >
      <span class="search-toggle" @click="searchExpanded = !searchExpanded">
        {{ searchExpanded ? "Hide Filters" : "Show Filters" }}
        <em class="el-icon-arrow-up" :class="{ 'is-collapsed': !searchExpanded }"></em>
      </span>
    </h3>

    <!-- search -->
    <div class="searchBox" v-show="searchExpanded">
      <el-form :model="formInline" ref="formInline" class="demo-form-inline">
        <div class="search-grid">
          <el-form-item prop="projectName">
            <el-input
              v-model="formInline.projectName"
              placeholder="Project Name"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item prop="projectCode">
            <el-input
              v-model="formInline.projectCode"
              placeholder="Project Code"
              @keyup.enter.native="submitSearch"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-toolbar">
        <div class="search-toolbar__actions">
          <el-button type="primary" class="search" @click="submitSearch('search')"
            >Search</el-button
          >
          <el-button class="reset" @click="resetForm('formInline')"
            >Reset</el-button
          >
        </div>
      </div>
    </div>
    <!-- toolbar, table & pagination share one panel -->
    <div class="client-panel">
      <div class="client-panel__toolbar">
        <div class="search-toolbar__extra">
          <columns-control
            :columns="columnsConfig"
            storage-key="cms.ourProducts.columns"
            @change="onColumnsChange"
          ></columns-control>
          <!-- filter & sort by -->
          <el-dropdown trigger="click" ref="filter">
          <span class="el-dropdown-link sortbox">
            <em class="filter"></em>
            Filter
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-form
              ref="formFilter"
              :model="formFilter"
              style="width: 300px; padding: 14px 24px"
            >
              <el-form-item
                label="Project Type"
                style="margin-bottom: 12px"
                prop="type"
              >
                <el-select
                  v-model="formFilter.type"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Project Location"
                style="margin-bottom: 12px"
                prop="location"
              >
                <el-select
                  v-model="formFilter.location"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in locationList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Project Status"
                style="margin-bottom: 12px"
                prop="projectStatus"
              >
                <el-select
                  v-model="formFilter.projectStatus"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in statusList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="Post Status"
                style="margin-bottom: 12px"
                prop="postStatus"
              >
                <el-select
                  v-model="formFilter.postStatus"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in postList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Project Code" style="margin-bottom: 12px">
                <el-select
                  v-model="formFilter.code"
                  :popper-append-to-body="false"
                >
                  <el-option value="All">All</el-option>
                  <el-option
                    v-for="(item, index) in ProductsList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div class="filterButton">
                <el-form-item style="margin-right: 15px; margin-bottom: 0">
                  <el-button
                    class="reset"
                    @click="
                      $refs.filter.hide();
                      resetForm('formFilter');
                    "
                    >Reset</el-button
                  >
                </el-form-item>
                <el-form-item style="margin-bottom: 0">
                  <el-button
                    type="primary"
                    class="search"
                    @click="
                      () => {
                        $refs.filter.hide();
                        submitSearch('apply');
                      }
                    "
                    >Apply</el-button
                  >
                </el-form-item>
              </div>
            </el-form>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link sortbox">
            <em class="sort"></em>
            Sort by
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="['name.EN,asc', 'id,asc']"
              >Project name (A-Z)</el-dropdown-item
            >
            <el-dropdown-item :command="['name.EN,desc', 'id,asc']"
              >Project name (Z-A)</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- table -->
    <el-table :data="tableData">
      <el-table-column v-if="isColumnVisible('projectId')" prop="projectId" label="Project ID"></el-table-column>
      <el-table-column v-if="isColumnVisible('salesOffice')" label="Sales Office">
        <template slot-scope="scope">{{
          $commonjs.salesOfficeMap(scope.row.salesOffice)
        }}</template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('region')" label="Region">
        <template slot-scope="scope">{{
          handleTableRegion(scope.row.region)
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="isColumnVisible('productType')"
        prop="productType"
        label="Product type"
      ></el-table-column>
      <el-table-column
        v-if="isColumnVisible('projectCode')"
        prop="projectCode"
        label="Project Code"
      ></el-table-column>
      <el-table-column v-if="isColumnVisible('projectName')" label="Project Name">
        <template slot-scope="scope">
          <p v-if="scope.row.name.EN">{{ scope.row.name.EN }}</p>
          <p v-if="scope.row.name.JA">{{ scope.row.name.JA }}</p>
          <p v-if="scope.row.name.ZH_HK">{{ scope.row.name.ZH_HK }}</p>
          <p v-if="scope.row.name.ZH_CN">{{ scope.row.name.ZH_CN }}</p>
        </template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('projectLocation')" label="Project Country">
        <template slot-scope="scope">{{
          $commonjs.locationMap(scope.row.projectLocation)
        }}</template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('projectState')" prop="status" label="Project State"> </el-table-column>
      <el-table-column v-if="isColumnVisible('projectRegion')" prop="projectRegion" label="Project Region">
      </el-table-column>
      <el-table-column v-if="isColumnVisible('projectStatus')" label="Project Status" width="150">
        <template slot-scope="scope">
          <div class="statusBox">
            <span style="width: 100%">{{
              $commonjs.projectStatusMap(scope.row.status)
            }}</span>
            <span v-if="scope.row.isNew" class="new_tag">NEW</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('isPost')" label="Post">
        <template slot-scope="scope">{{
          scope.row.isPost ? "Online" : "Offline"
        }}</template>
      </el-table-column>
      <el-table-column v-if="isColumnVisible('lastPostDate')" label="Last Post Date">
        <template slot-scope="scope">{{
          scope.row.lastStartDate && scope.row.lastEndDate
            ? scope.row.lastStartDate + " ~ " + scope.row.lastEndDate
            : "-"
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="isColumnVisible('updatedAt')"
        prop="updatedAt"
        label="Last update"
        :formatter="$commonjs.tableFormatDateTime"
      ></el-table-column>
      <el-table-column label="Operation">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="Edit" placement="top">
            <em
              class="edit"
              style="margin-right: 10px"
              @click="handleEdit(scope.row)"
            ></em>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="Delete"
            placement="top"
          >
            <em class="delete" @click="handleDelete(scope.row)"></em>
          </el-tooltip>
          <el-button size="mini" @click="handleAddClone(scope.row)"
            >Clone</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- page -->
    <app-pagination
      @size-change="
        v => {
          currentSize = v;
          currentPage = 1;
          getList();
        }
      "
      @current-change="
        v => {
          currentPage = v;
          getList();
        }
      "
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :total="total"
      :page-size="currentSize"
    ></app-pagination>
    </div>
  </div>
</template>

<script>
import {
  projectList,
  projectDelete,
  getProjectLocation,
  getProjectStatus,
  getProjectType,
  appProducts
} from "@/request/api";
export default {
  name: "ourProducts",
  data() {
    return {
      tableData: [],
      ProductsList: [],
      currentSize: 10,
      currentPage: 1,
      total: 0,
      formLabelWidth: "96px",
      formUser: {
        id: 0,
        username: "",
        password: "",
        roles: []
      },
      formInline: {
        projectName: ""
      },
      formFilter: {
        type: "All",
        location: "All",
        projectStatus: "All",
        postStatus: "All",
        code: "All"
      },
      sort: ["name.EN,asc", "id,asc"],
      typeList: [],
      statusList: [],
      locationList: [],
      postList: [
        { name: "Online", code: true },
        { name: "Offline", code: false }
      ],
      searchExpanded: true,
      columnsConfig: [
        { prop: "projectId", label: "Project ID", visible: true },
        { prop: "salesOffice", label: "Sales Office", visible: true },
        { prop: "region", label: "Region", visible: true },
        { prop: "productType", label: "Product type", visible: true },
        { prop: "projectCode", label: "Project Code", visible: true },
        { prop: "projectName", label: "Project Name", visible: true },
        { prop: "projectLocation", label: "Project Country", visible: true },
        { prop: "projectState", label: "Project State", visible: true },
        { prop: "projectRegion", label: "Project Region", visible: true },
        { prop: "projectStatus", label: "Project Status", visible: true },
        { prop: "isPost", label: "Post", visible: true },
        { prop: "lastPostDate", label: "Last Post Date", visible: true },
        { prop: "updatedAt", label: "Last update", visible: true },
      ],
      visibleColumnProps: [
        "projectId",
        "salesOffice",
        "region",
        "productType",
        "projectCode",
        "projectName",
        "projectLocation",
        "projectState",
        "projectRegion",
        "projectStatus",
        "isPost",
        "lastPostDate",
        "updatedAt",
      ],
    };
  },
  methods: {
    isColumnVisible(prop) {
      return this.visibleColumnProps.includes(prop);
    },
    onColumnsChange(visibleProps) {
      this.visibleColumnProps = visibleProps;
    },
    getList(val) {
      let params = {
        page: this.currentPage - 1,
        size: this.currentSize,
        sort: this.sort
      };
      if (this.formInline.projectName)
        params["projectName"] = this.formInline.projectName;
      if (this.formInline.projectCode) {
        params["projectCode"] = this.formInline.projectCode;
      }
      if (this.formFilter.code && this.formFilter.code != "All") {
        params["projectCode"] = this.formFilter.code;
      }

      if (this.formFilter.type && this.formFilter.type != "All")
        params["projectType"] = this.formFilter.type;
      if (this.formFilter.location && this.formFilter.location != "All")
        params["projectLocation"] = this.formFilter.location;
      if (
        this.formFilter.projectStatus &&
        this.formFilter.projectStatus != "All"
      )
        params["productStatus"] = this.formFilter.projectStatus;
      if (this.formFilter.postStatus && this.formFilter.postStatus != "All")
        params["isPost"] = this.formFilter.postStatus;
      projectList(params).then(res => {
        this.tableData = res.data.content;
        this.total = res.data.totalElements;
      });
    },

    getProducts() {
      appProducts().then(res => {
        var option = [];
        res.data.map(item => {
          option.push({ code: item.productNumber, name: item.productNumber });
        });
        console.log(option);
        this.ProductsList = option;
      });
    },

    getLocation() {
      getProjectLocation().then(res => {
        this.locationList = res.data.payload;
      });
    },
    getType() {
      getProjectType().then(res => {
        this.typeList = res.data.payload;
      });
    },
    getStatus() {
      getProjectStatus().then(res => {
        this.statusList = res.data.payload;
      });
    },

    handleAdd() {
      this.$router.push({ path: "/createProject" });
    },
    handleAddClone(row) {
      this.$router.push({
        path: "/editProjectClone/" + row.id,
      });
    },
    handleEdit(row) {
      this.$router.push({ path: "/editProject/" + row.id });
    },
    handleDelete(row) {
      const h = this.$createElement;
      this.$msgbox({
        message: h("div", { style: "padding:15px 0" }, [
          h(
            "p",
            {
              style:
                "color:#003448;text-align:center;font-size:20px;font-weight:bold;line-height: 1.5;"
            },
            "Are you sure to delete this record?"
          )
        ]),
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        confirmButtonClass: "msg_button_half",
        cancelButtonClass: "msg_button_half",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        callback: (action, instance) => {
          let button = action;
          if (button == "confirm") {
            projectDelete(row.id).then(res => {
              if (res.data.status == "00") {
                this.$message.success("Reocrd is deleted");
                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
    submitSearch(val) {
      this.currentPage = 1;
      this.getList(val);
    },
    handleCommand(command) {
      this.sort = command;
      this.submitSearch();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formFilter = {
        type: "All",
        location: "All",
        projectStatus: "All",
        postStatus: "All",
        code: "All"
      };
      this.getList();
    },
    handleTableRegion(arr) {
      let str = "";
      arr.forEach(item => {
        let name = this.$commonjs.regionMap(item);
        if (str) {
          str = str + ", " + name;
        } else {
          str = str + name;
        }
      });
      return str;
    }
  },
  created: function() {
    this.$emit("header", true);
    this.$commonjs.initRegionsMap();
    this.getList();
    this.getLocation();
    this.getType();
    this.getStatus();
    this.getProducts();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "editProject") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  activated() {
    if (this.$route.params.update) {
      this.getList();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.search-toggle {
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  float: right;
  margin-right: 20px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #003448;
  cursor: pointer;
}
.search-toggle .el-icon-arrow-up {
  transition: transform 0.2s ease;
}
.search-toggle .el-icon-arrow-up.is-collapsed {
  transform: rotate(180deg);
}

.searchBox {
  padding: 20px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
}

.search-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 20px;
}

.search-grid /deep/ .el-form-item {
  margin-bottom: 16px;
}

.search-grid /deep/ .el-input__inner {
  width: 100%;
}

.search-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 12px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid #e6ebee;
}

.search-toolbar__actions .el-button {
  min-width: 96px;
}

.search-toolbar__extra {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

/* Toolbar, table & pagination merged into one panel instead of three separate cards. */
.client-panel {
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 8px;
  overflow: hidden;
}

.client-panel__toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px;
  border-bottom: 1px solid #e6ebee;
}

.client-panel /deep/ .el-table {
  border: none;
  border-radius: 0;
}

.client-panel /deep/ .app-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0;
  border-top: 1px solid #e6ebee;
}

.filterButton {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.sortbox {
  cursor: pointer;
}
.statusBox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.new_tag {
  background: #e36f1e;
  color: #fff;
  width: 52px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  border-radius: 5px;
  margin-top: 10px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/product/ourProducts.vue